import { takeLatest, put, call } from 'redux-saga/effects';
import { revokeInvitationStart } from './actions';
import { loading, success, failure } from './slice';
import { revokeInvitation } from './service';
import { Action } from '@reduxjs/toolkit';

function* revokeInvitationFlow(action: Action<unknown>) {
  if (revokeInvitationStart.match(action)) {
    try {
      yield put(loading());
      yield call(revokeInvitation, action.payload.id);
      yield put(success());
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export function* onRevokeInvitationStart() {
  yield takeLatest(revokeInvitationStart, revokeInvitationFlow);
}
